<template>
  <div id="global-search-overlay">

    <b-container class="global-search-overlay-container">
      <div id="global-search-overlay-inner">
        <div id="global-search-overlay-header">
          <b-form-input :value="value" :placeholder="$t('recherche_label')" autofocus
            @input="onSearchInput"></b-form-input>
          <button id="global-search-close" type="button" aria-label="Fermer la recherche" @click="onClose">
            &times;
          </button>
        </div>

        <div v-if="showNoResultsMessage">Aucun résultat trouvé pour la recherche "{{ value }}"</div>
        <div id="global-search-overlay-results" class="global-search-overlay-scroll">
          <div v-for="result in searchResults" :key="result.id" class="global-search-item"
            @click="onResultClick(result)">

            <div class="">
              <div class="global-search-item-info d-flex flex-row align-items-center">
                <img v-if="result.nation" class="flag"
                  :src="'https://sportips.fr/live/img/Flags/' + result.nation + '.jpg'" /> <span><b>{{
                    result.dossard != '' ? '[' + result.dossard + ']' : '' }} {{
                      result.nom }} {{ result.prenom }}</b></span>

              </div>
              <div class="global-search-item-info-course  font-weight-light">
                <span>{{ result.course }}</span>
              </div>
            </div>
          </div>
        </div>


      </div>
    </b-container>



  </div>
</template>

<script>
const SEARCH_DEBOUNCE_MS = 200;

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      searchDebounceTimer: null,
      isDebouncing: false,
      isSearching: false,
    };
  },
  computed: {
    showNoResultsMessage() {
      const q = (this.value || "").trim();
      return (
        q.length > 0 &&
        this.searchResults.length === 0 &&
        !this.isDebouncing &&
        !this.isSearching
      );
    },
    searchResults() {
      if (this.$store.state.showParticipantsTab) {
        return this.searchInscriptions;
      } else {
        return this.searchCoureurs;
      }
    },

    searchCoureurs() {
      return this.$store.getters["listCoureurs/searched_participants"];
    },
    searchInscriptions() {
      return this.$store.getters["listInscriptions/searchedInscriptions"];
    }

  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.scheduleSearch(value);
      },
    },
  },
  beforeDestroy() {
    if (this.searchDebounceTimer != null) {
      clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = null;
    }
  },
  methods: {
    onClose() {
      this.isDebouncing = false;
      this.isSearching = false;
      if (this.searchDebounceTimer != null) {
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = null;
      }
      this.$emit("close");
      this.resetSearchResults();
    },
    onSearchInput(value) {
      this.$emit("input", value);
    },
    resetSearchResults() {
      if (this.$store.state.showParticipantsTab) {
        this.$store.commit("listInscriptions/setSearchFilter", "");
        this.$store.commit("listInscriptions/setSearchedInscriptions", []);
      } else {
        this.$store.commit("listCoureurs/setSearchFilter", "");
        this.$store.commit("listCoureurs/resetSearchedParticipants");
      }
    },
    scheduleSearch(value) {
      if (this.searchDebounceTimer != null) {
        clearTimeout(this.searchDebounceTimer);
        this.searchDebounceTimer = null;
      }

      if (value === "") {
        this.isDebouncing = false;
        this.resetSearchResults();
        return;
      }

      this.isDebouncing = true;
      this.searchDebounceTimer = setTimeout(() => {
        this.searchDebounceTimer = null;
        this.isDebouncing = false;
        this.runDebouncedSearch(value);
      }, SEARCH_DEBOUNCE_MS);
    },
    async runDebouncedSearch(value) {
      const isLive = !this.$store.state.showParticipantsTab;
      this.isSearching = true;
      try {
        if (isLive) {
          await this.makeLiveSearch(value);
        } else {
          await this.makeInscriptionsSearch(value);
        }
      } finally {
        this.isSearching = false;
      }
    },
    async makeLiveSearch(value) {
      this.$store.commit("listCoureurs/setSearchFilter", value);
      this.$store.dispatch("listCoureurs/searchInscriptions");
    },
    async makeInscriptionsSearch(value) {
      this.$store.commit("listInscriptions/setSearchFilter", value);
      this.$store.dispatch("listInscriptions/searchInscriptions");
    },

    onResultClick(result) {
      if (this.$store.state.showParticipantsTab) {
        if (result.id_coureur_live) {
          this.$router.push('/' + this.$store.state.module.base + '/fiche/' + result.id_coureur_live[0]);
        }
      } else {
        this.$router.push('/' + this.$store.state.module.base + '/fiche/' + result.id);

      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
